module.exports = __webpack_public_path__ + "img/editora-tres.8fa06296.svg";